/* Iguala el botón de compra de Releasit a los CTA del cuerpo: de borde a borde, sin
   radio ni borde, con el verde de la etiqueta del producto.

   Por qué hace falta JavaScript y no basta con CSS: Releasit escribe los estilos en el
   atributo style del elemento y además con !important
   (border-radius: 36px !important; border: 5px solid #000 !important; ...).
   Un inline !important gana a cualquier regla de hoja de estilos, así que la única forma
   de sobreescribirlo es volver a escribir el inline con setProperty(..., 'important').

   La app puede repintar el botón al cambiar de variante o al hidratar, por eso queda un
   MutationObserver vigilando el atributo style.

   Lo limpio sería cambiarlo en el panel de Releasit (radio 0, borde 0); esto es el
   arreglo desde el tema mientras tanto. */
(function () {
  if (window.__lvBoton) return;
  window.__lvBoton = 1;

  var ESTILOS = {
    'border-radius': '0px',
    'border': '0',
    'background': 'linear-gradient(180deg,#17A80A 0%,#0C8A00 100%)',
    'box-shadow': '0 -1px 0 rgba(255,255,255,.16) inset, 0 10px 26px rgba(12,138,0,.32)',
    'width': '100%',
  };

  function pinta(el) {
    if (!el) return;
    el.dataset.lvPintado = '1';
    for (var k in ESTILOS) el.style.setProperty(k, ESTILOS[k], 'important');
  }

  function buscar() {
    // El botón flotante conserva su forma de botón: solo se iguala el que va en la ficha.
    var todos = document.querySelectorAll('#_rsi-buy-now-button, [id*="rsi-buy-now"]');
    for (var i = 0; i < todos.length; i++) {
      var e = todos[i];
      if (getComputedStyle(e).position === 'fixed') continue;
      pinta(e);
      vigila(e);
    }
  }

  function vigila(el) {
    if (el.__lvObs) return;
    el.__lvObs = 1;
    new MutationObserver(function () {
      if (el.style.borderRadius !== '0px') pinta(el);
    }).observe(el, { attributes: true, attributeFilter: ['style'] });
  }

  // Releasit inyecta tarde: se reintenta durante unos segundos y luego se deja de mirar.
  var intentos = 0;
  var t = setInterval(function () {
    buscar();
    if (++intentos > 40) clearInterval(t);
  }, 250);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buscar);
  } else {
    buscar();
  }
})();
